const METERS_PER_MILE = 1609.344;

/** @param {number} miles */
export const milesToMeters = miles => miles * METERS_PER_MILE;
